import * as React from 'react';
import PropTypes from 'prop-types';
import { DataGrid, GridToolbarContainer, GridToolbarFilterButton } from '@mui/x-data-grid';
import { makeStyles } from "@mui/styles";
import { useState } from "react";
import { toast } from "react-toastify";
import { httpClient } from "../../lib/HttpClient";
import { IconButton, TextField } from "@mui/material";
import ClearIcon from '@mui/icons-material/Clear';
import SearchIcon from '@mui/icons-material/Search';
import useTranslation ,{useLocalization} from  "../../lib/localization";
import LayoutWithSidebar from "../../components/LayoutWithSidebar";
import useEffectAsync from "../../lib/helper/useEffectAsync";
import AddLinkIcon from '@mui/icons-material/AddLink';
import SeverityPill from '../../components/SeverityPill';

const useStyles = makeStyles((theme) => ({
    columnAction: {
        width: theme.spacing(1),
        padding: theme.spacing(0, 1),
    }
}));

const CustomToolbar = ({ setFilterButtonEl, value, clearSearch, onChange }) => (
    <GridToolbarContainer>
        <GridToolbarFilterButton ref={setFilterButtonEl} />
        <TextField
            variant="standard"
            value={value}
            onChange={onChange}
            placeholder="Search…"
            InputProps={{
                startAdornment: <SearchIcon fontSize="small" />,
                endAdornment: (
                    <IconButton
                        title="Clear"
                        aria-label="Clear"
                        size="small"
                        style={{ visibility: value ? 'visible' : 'hidden' }}
                        onClick={clearSearch}
                    >
                        <ClearIcon fontSize="small" />
                    </IconButton>
                ),
            }}
            sx={{
                width: {
                    xs: 1,
                    sm: 'auto',
                },
                m: (theme) => theme.spacing(1, 0.5, 1.5),
                '& .MuiSvgIcon-root': {
                    mr: 0.5,
                },
                '& .MuiInput-underline:before': {
                    borderBottom: 1,
                    borderColor: 'divider',
                },
            }}
        />
    </GridToolbarContainer>
);

CustomToolbar.propTypes = {
    setFilterButtonEl: PropTypes.func.isRequired,
    clearSearch: PropTypes.func.isRequired,
    onChange: PropTypes.func.isRequired,
    value: PropTypes.string.isRequired,
};

export default function PaymentSessionsList() {

    const t = useTranslation();
    var {language} = useLocalization();
    const classes = useStyles();
    const [payments, setPayments] = useState([]);
    const [filterButtonEl, setFilterButtonEl] = React.useState(null);
    const [searchText, setSearchText] = React.useState('');

    const columns = [
        // { field: 'id', headerName: 'ID', hide: true },
        {
            field: 'title',
            headerName: t('payment.paymentTitle'),
            width: 110,
            editable: false,
        },
        // {
        //     field: 'txtId',
        //     headerName: t('payment.transactionDetails'),
        //     width: 120,
        //     renderCell: (cellValues) => {
        //         return (cellValues.row.txId &&
        //             <IconButton onClick={() => copyLink(cellValues.row)} aria-label="delete" color="primary">
        //                 <AddLinkIcon />
        //             </IconButton>
        //         );
        //     },
        //     editable: false,
        // },
        {
            field: 'payoutAddress',
            headerName: t('payment.payoutAddress'),
            width: 300,
            editable: false,
        },
        {
            field: 'amount',
            headerName: t('payment.amount'),
            width: 150,
            typr: 'number',
            editable: false,
        },
        {
            field: 'sessionId',
            headerName: t('payment.paymentId'),
            width: 300,
            editable: false,
        },
        {
            field: 'datetime',
            headerName: t('payment.datetime'),
            width: 150,
            renderCell: (cellValues) => {
                return (
                    cellValues.row && new Date(cellValues.row.datetime).toLocaleString(language)
                );
            },
            editable: false,
        },
        {
            field: 'status',
            headerName: t('payment.status'),
            width: 150,
            renderCell: (cellValues) => {
                return (
                    cellValues.row && <SeverityPill
                        color={(cellValues?.row?.status === 'WaitingToReceive' && 'secondary')
                            || (cellValues?.row?.status === 'Done' && 'success')
                            || (cellValues?.row?.status === 'Expired' && 'error')
                            || (cellValues?.row?.status === 'Failed' && 'error')
                            || (cellValues?.row?.status === 'Declined' && 'error')
                            || 'warning'}
                    >
                        {(cellValues?.row?.status === 'WaitingToReceive' || cellValues?.row?.status === 'Done' || cellValues.row.status === 'Expired' || cellValues.row.status === 'Failed' || cellValues.row.status === 'Declined') ? t(cellValues.row.status) : t("InProgress")}
                    </SeverityPill>
                );
            },
            editable: false,
        }
    ];

    useEffectAsync(async () => {
        try {
            var payments = await httpClient.Get("/api/payment/sessions");
            setPayments(payments);
        } catch (error) {

        }

    }, [])

    const copyLink = (item) => {
        navigator.clipboard.writeText(`https://tronscan.org/#/transaction/${item.txId}`);
        toast.success(t("payment.txIdCopied"));
    }

    React.useEffect(() => {
        setRows(payments);
    }, [payments]);

    const [rows, setRows] = React.useState(payments);

    function escapeRegExp(value) {
        return value.replace(/[-[\]{}()*+?.,\\^$|#\s]/g, '\\$&');
    }

    const requestSearch = (searchValue) => {
        setSearchText(searchValue);
        const searchRegex = new RegExp(escapeRegExp(searchValue), 'i');
        const filteredRows = payments.filter((row) => {
            return Object.keys(row).some((field) => {
                if (row[field])
                    return searchRegex.test(row[field].toString());
            });
        });
        setRows(filteredRows);
    };

    return (
        <LayoutWithSidebar>
            <div style={{ height: 550, width: '100%' }}>
                <DataGrid
                    disableColumnMenu
                    columns={columns}
                    rows={rows}
                    components={{
                        Toolbar: CustomToolbar,
                    }}
                    componentsProps={{
                        panel: {
                            anchorEl: filterButtonEl,
                        },
                        toolbar: {
                            setFilterButtonEl, // filter
                            value: searchText, // search
                            onChange: (event) => requestSearch(event.target.value), // search
                            clearSearch: () => requestSearch(''), // search
                        },
                    }}
                />
            </div>
        </LayoutWithSidebar >
    )

}